import React, { useEffect, useRef } from 'react';
import { FiFileText, FiX, FiPhoneIncoming, FiPhoneOutgoing } from 'react-icons/fi';

// Qo'ng'iroq tugagach avtomatik ochiladigan IXTIYORIY izoh kartasi.
// Ataylab modal emas: fon qoraytirilmaydi, sahifa bloklanmaydi — operator
// kartani e'tiborsiz qoldirib keyingi qo'ng'iroqni yuqoridagi lentadan ko'tara
// oladi yoki raqam tera oladi. Softphone vidjetining chap yonida turadi, uni
// to'smaydi. Matn holati SoftphoneWidget'da: yangi qo'ng'iroq boshlanganda
// bo'sh karta o'sha yerda yopiladi, yozilgan matn esa saqlanib qoladi.
export default function PostCallNote({ note, right, onChange, onSave, onClose }) {
  const inputRef = useRef(null);

  useEffect(() => {
    // Operator boshqa maydonda yozayotgan bo'lsa (masalan kontakt formasi) fokusni tortib olmaymiz.
    const a = document.activeElement;
    const typing = a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName);
    if (!typing && inputRef.current) inputRef.current.focus();
  }, [note.key]);

  const canSave = note.text.trim().length > 0;

  const onKeyDown = (e) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      onClose();
    } else if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && canSave) {
      e.preventDefault();
      onSave();
    }
  };

  const m = Math.floor(note.durationSec / 60);
  const s = note.durationSec % 60;
  const inbound = note.direction === 'inbound';
  const Icon = inbound ? FiPhoneIncoming : FiPhoneOutgoing;

  return (
    <div
      style={{ ...styles.card, right, maxWidth: `calc(100vw - ${right + 20}px)` }}
      onKeyDown={onKeyDown}
      role="dialog"
      aria-label="Qo'ng'iroq izohi"
    >
      <div style={styles.head}>
        <span style={styles.title}>
          <FiFileText size={15} color="#3b82f6" /> Qo'ng'iroq izohi
        </span>
        <span style={styles.optional}>ixtiyoriy</span>
        <button type="button" style={styles.closeBtn} onClick={onClose} title="Yopish (Esc)">
          <FiX size={16} />
        </button>
      </div>

      <div style={styles.who}>
        <Icon size={13} color={inbound ? '#10b981' : '#3b82f6'} style={{ flexShrink: 0 }} />
        <span style={styles.name}>{note.name || note.number}</span>
        {note.name && <span style={styles.num}>{note.number}</span>}
        <span style={styles.dur}>{String(m).padStart(2, '0')}:{String(s).padStart(2, '0')}</span>
      </div>

      <textarea
        ref={inputRef}
        value={note.text}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Suhbat haqida qisqacha yozing…"
        rows={4}
        style={styles.input}
      />

      <div style={styles.actions}>
        <button type="button" style={styles.cancelBtn} onClick={onClose}>
          Bekor qilish
        </button>
        <button
          type="button"
          style={{ ...styles.saveBtn, ...(canSave ? {} : styles.saveBtnOff) }}
          onClick={onSave}
          disabled={!canSave}
        >
          Saqlash
        </button>
      </div>
      <div style={styles.hint}>Ctrl+Enter — saqlash · Esc — yopish</div>
    </div>
  );
}

const styles = {
  card: {
    position: 'fixed', bottom: 20, width: 320, zIndex: 998,
    background: '#1e293b', border: '1px solid #2d3a4f', borderRadius: 16,
    padding: 16, boxShadow: '0 12px 48px rgba(0,0,0,0.4)', boxSizing: 'border-box',
  },
  head: { display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 },
  title: { display: 'flex', alignItems: 'center', gap: 6, fontSize: 14, fontWeight: 700, color: '#f1f5f9' },
  optional: {
    fontSize: 11, color: '#94a3b8', background: '#0f172a', border: '1px solid #2d3a4f',
    borderRadius: 6, padding: '1px 6px',
  },
  closeBtn: {
    marginLeft: 'auto', background: 'transparent', border: 'none', color: '#94a3b8',
    cursor: 'pointer', width: 24, height: 24, borderRadius: 6,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  who: {
    display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10,
    fontSize: 13, color: '#f1f5f9', minWidth: 0,
  },
  name: { fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  num: { fontSize: 12, color: '#94a3b8', fontFamily: 'monospace', whiteSpace: 'nowrap' },
  dur: { marginLeft: 'auto', fontSize: 12, color: '#94a3b8', fontFamily: 'monospace' },
  input: {
    width: '100%', padding: '10px 12px', background: '#0f172a',
    border: '1px solid #2d3a4f', borderRadius: 10, color: '#f1f5f9',
    fontSize: 14, outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box',
    resize: 'vertical', minHeight: 80,
  },
  actions: { display: 'flex', gap: 8, marginTop: 10 },
  cancelBtn: {
    flex: 1, padding: 10, background: '#0f172a', border: '1px solid #2d3a4f',
    borderRadius: 10, color: '#94a3b8', fontSize: 14, fontWeight: 600,
    cursor: 'pointer', fontFamily: 'inherit',
  },
  saveBtn: {
    flex: 1, padding: 10, background: '#10b981', border: 'none',
    borderRadius: 10, color: '#fff', fontSize: 14, fontWeight: 700,
    cursor: 'pointer', fontFamily: 'inherit',
  },
  saveBtnOff: { opacity: 0.45, cursor: 'default' },
  hint: { marginTop: 8, fontSize: 11, color: '#64748b', textAlign: 'center' },
};
